import { useContext } from 'react';
import { ScopeContext } from '@bingads-webui-react/scope-service';
import { useReportSignupConversion } from '@bingads-webui-campaign-react/pmax-landing-utils';

// Headless reporter: fires the signup conversion pixels once the customer is created
// (a non-empty `cid` appears in scope). Mount it inside the scope provider.
export function SignupConversionPixelsReporter() {
  const { scope } = useContext(ScopeContext);
  const cid = scope && scope.values ? scope.values.cid : undefined;
  useReportSignupConversion(cid);
  return null;
}
